export const useIsValidEmail = (email: string) => {
  if (email == "") return false;

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
